import React from "react";
import PropTypes from "prop-types";

const propTypes = {
    width: PropTypes.number.isRequired
};

const defaultProps = {};

export default function LinkedIn(props) {
    const {width, className} = props;

    const height = (212.6 / 212.6) * width

    return (
        <React.Fragment>
            <svg className={className} viewBox="0 0 212.6 212.6" xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
                <path d="M189.2 9H23.4C15.4 9 9 15.3 9 23v166.5c0 7.7 6.4 14 14.4 14h165.8c7.9 0 14.4-6.3 14.4-14V23c0-7.7-6.5-14-14.4-14zM66.7 174.8H37.8V82h28.9v92.8zM52.3 69.3c-9.3 0-16.7-7.5-16.7-16.7s7.5-16.7 16.7-16.7S69 43.4 69 52.6s-7.5 16.7-16.7 16.7zm122.5 105.5H146v-45.2c0-10.8-.2-24.6-15-24.6-15 0-17.3 11.7-17.3 23.8v45.9H84.8V82h27.7v12.7h.4c3.8-7.3 13.3-15 27.3-15 29.2 0 34.6 19.2 34.6 44.2v50.9z" fill="currentColor"/>
            </svg>
        </React.Fragment>
    );
}

LinkedIn.propTypes = propTypes;
LinkedIn.defaultProps = defaultProps;
